import React from 'react';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';
import { contactInfo } from '../mock';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    if (window.location.pathname !== '/') {
      window.location.href = '/#' + id;
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-slate-900 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img
              src="/logo-upline.png"
              alt="Upline Global Solutions"
              className="h-32 w-auto mb-4"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Leading provider of premium refurbished medical equipment across India. Quality healthcare solutions you can trust.
            </p>
            <div className="flex space-x-3">
              <a
                href={`https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-teal-600 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-colors"
              >
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-slate-400 hover:text-teal-400 transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className="text-slate-400 hover:text-teal-400 transition-colors"
                >
                  Products
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-slate-400 hover:text-teal-400 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-us')}
                  className="text-slate-400 hover:text-teal-400 transition-colors"
                >
                  Why Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-slate-400 hover:text-teal-400 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>CT Scanners</li>
              <li>MRI Systems</li>
              <li>Cath Labs</li>
              <li>PET CT Systems</li>
              <li>Installation & Training</li>
              <li>Maintenance Support</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <Phone className="text-teal-400 flex-shrink-0 mt-0.5" size={16} />
                <a href={`tel:${contactInfo.phone}`} className="text-slate-400 hover:text-teal-400 transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="text-teal-400 flex-shrink-0 mt-0.5" size={16} />
                <a href={`mailto:${contactInfo.email}`} className="text-slate-400 hover:text-teal-400 transition-colors break-all">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-teal-400 flex-shrink-0 mt-0.5" size={16} />
                <span className="text-slate-400">
                  {contactInfo.address.line1}, {contactInfo.address.line2}, {contactInfo.address.city}, {contactInfo.address.state} {contactInfo.address.pincode}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} Upline Global Solutions. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <button className="text-slate-400 hover:text-teal-400 transition-colors">
                Privacy Policy
              </button>
              <button className="text-slate-400 hover:text-teal-400 transition-colors">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};